import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const COLORS = ["#0072A7", "#57B5E1", "#80d9ff"];

export default function Chart(props) {
  return (
    <ResponsiveContainer aspect={3}>
      <LineChart
        className="line-chart"
        data={props.data}
        style={{ marginBottom: 6 }}
      >
        <Line
          type="monotone"
          dot={{
            stroke: COLORS[props.index % COLORS.length] || "#63c2de",
            strokeWidth: 4,
          }}
          activeDot={{ stroke: "white", strokeWidth: 2 }}
          dataKey={props.dataKey ? props.dataKey : "pv"}
          stroke={COLORS[props.index % COLORS.length] || "#63c2de"}
          strokeWidth={4}
        />
        <Tooltip />
        <XAxis dataKey="name" />
        <YAxis />
      </LineChart>
    </ResponsiveContainer>
  );
}
